import React from 'react';
import { useIntl } from 'react-intl';

import ChevronDown from '@bitcoin-portal/verse-web-components/dist/Icons/ChevronDown';
import Link from '@bitcoin-portal/verse-web-components/dist/Link';

import { useTrackEvent } from '@hooks/useTrackEvent';

import { Divider, Line, Wrapper } from './styled';

const Links = () => {
  const trackEvent = useTrackEvent();
  const { messages } = useIntl();

  const links = messages['lounge.noVerse.links'] as unknown as {
    label: string;
    href: string;
  }[];

  return (
    <Wrapper>
      {links.map(({ label, href }, idx) => (
        <React.Fragment key={label}>
          {idx !== 0 && (
            <Divider>
              <Line reverse />
              OR
              <Line />
            </Divider>
          )}
          <Link
            href={href}
            newTab={href?.startsWith('https')}
            onClick={() => {
              trackEvent('tap', {
                to: href,
              });
            }}
          >
            {label}
            <ChevronDown size="16px" />
          </Link>
        </React.Fragment>
      ))}
    </Wrapper>
  );
};

export default Links;
